import { QueryClientProvider } from '@tanstack/react-query';
import { CatchBoundary, RouterProvider } from '@tanstack/react-router';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { ConsentBanner } from '@src/components/consent';
import { Composer, Error } from '@src/components/utils';
import { AuthenticationProvider, PermissionsProvider } from '@src/context'; // AUTH: Commented out Auth/Permissions providers import
// AUTH: Commented out useAuthentication hook import
import { Devtools } from '@src/corelib/devtools';
import { queryClient } from '@src/corelib/query';
import router from '@src/router';
import { lightTheme } from '@src/themes';

import './styles/theme.css';


const PROVIDERS = [
  { element: ThemeProvider, props: { theme: lightTheme } },
  { element: StyledEngineProvider, props: { injectFirst: true } },
  { element: LocalizationProvider, props: { dateAdapter: AdapterDateFns } },
  { element: AuthenticationProvider, props: {} }, // AUTH: Commented out AuthenticationProvider
  { element: PermissionsProvider, props: {} }, // AUTH: Commented out PermissionsProvider
  { element: QueryClientProvider, props: { client: queryClient } },
];

function InnerApp() {
  // const auth = useAuthentication(); // AUTH: Commented out hook usage
  const auth = { isAuthenticated: true, user: { name: 'Dev User' } /* Add any necessary mock auth object properties here */ }; // AUTH: Mocked auth object for testing

  // Pass a mock 'auth' context to the router
  return <RouterProvider router={router} context={{ auth }} />;
}

function App() {
  return (
    <CatchBoundary errorComponent={Error} getResetKey={() => 'reset'}>
      <Composer providers={PROVIDERS}>
        <CssBaseline />
        <InnerApp />
        {/* Inside Composer so it inherits ThemeProvider; outside InnerApp so it
            is not tied to route rendering. */}
        <ConsentBanner />
        <Devtools router={router} />
      </Composer>
    </CatchBoundary>
  );
}

export default App;
